import { Link, createFileRoute, useLocation } from '@tanstack/react-router'
import { getLocaleFromPath, withLocalePath } from '@/lib/i18n-utils'
import { localizedPageHead } from '@/lib/seo-head'
import { participationCopy } from '@/lib/participation-copy'

export const Route = createFileRoute('/{-$locale}/terms')({
  head: ({ params }) => localizedPageHead('terms', params.locale),
  component: TermsOfServicePage,
})

function TermsOfServicePage() {
  const locale = getLocaleFromPath(useLocation().pathname)
  const copy = participationCopy[locale === 'bs-BA' ? 'bs' : 'en']
  return <article className="ledger-wrap py-12 md:py-16">
    <Link className="ledger-link" to={withLocalePath('/', locale)}>{copy.back}</Link>
    <h1 className="ledger-display mt-8 max-w-[24ch] text-[clamp(2.4rem,6vw,4.4rem)]">{copy.title}</h1>
    <p className="ledger-muted mt-5">{copy.updated}</p>
    <div className="mt-12 max-w-[70ch] space-y-10">
      {copy.sections.map(section => <section key={section.title} id={'id' in section ? section.id : undefined} className="scroll-mt-24">
        <h2 className="ledger-serif text-2xl">{section.title}</h2>
        <p className="mt-4 leading-relaxed">{section.body}</p>
      </section>)}
    </div>
    <nav aria-label={copy.title} className="mt-12 flex flex-wrap gap-6 border-t border-[var(--rule)] pt-7">
      <Link className="ledger-link" to={withLocalePath('/privacy', locale)}>{copy.privacy}</Link>
      <Link className="ledger-link" to={withLocalePath('/community', locale)}>{copy.community}</Link>
      <a className="ledger-link" href="mailto:hello@horizon-tech.io">{copy.contact}</a>
    </nav>
  </article>
}
